import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid, Button } from "@mui/material/";
import CleansingMenu from "../Products/Product/Menu/CleansingMenu";
import { useLocation } from "react-router-dom";

import { HashLink } from "react-router-hash-link";
import { collection, db, query, getDocs, orderBy } from "../../firebase";

import CircularProgress from "@mui/material/CircularProgress";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import AllReviewsOnePage from "./AllReviewsOnePage";
import { useTranslation } from "react-i18next";
import Pagination from "@mui/material/Pagination";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const AllReviews = () => {
  const { t, i18n } = useTranslation();
  // const location = useLocation();
  const numOfReviews = 10;
  const [reviews, setReviews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  console.log("currentPage", currentPage);

  let query2 = useQuery();
  let name = query2.get("name");
  let link = query2.get("link") + "#top";

  let productId = query2.get("productId");
  let location = query2.get("location");
  // console.log("name", name);
  // console.log("productId", productId);
  // console.log("reviews", reviews);

  const getReviews = async () => {
    setLoading(true);
    setReviews([]);
    let dbName = location + "_reviews_" + productId;

    let ref = await collection(db, dbName);
    const q = query(ref, orderBy("created", "desc"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      console.log(doc.id, " => ", doc.data());

      setReviews((old) => old.concat({ ...doc.data(), id: doc.id }));
    });
    setLoading(false);
  };
  useEffect(() => {
    getReviews();
  }, []);

  const handleChange = (event, value) => {
    console.log(value);
    console.log(event);

    if (value === "Prev") {
      setCurrentPage(currentPage - 1);
    } else if (value === "Next") {
      setCurrentPage(currentPage + 1);
    } else {
      setCurrentPage(+event.target.outerText - 1); // clicked number
    }
  };

  console.log("currentPage", currentPage);
  console.log(reviews.length / numOfReviews);
  return (
    <>
      <Grid container sx={{ px: 10, mb: 10 }}>
        {/* md={3} */}
        <section id="top"></section>
        <CleansingMenu />
        <Grid
          item
          md={8}
          sx={{ pb: 2, pt: 2, display: "flex", flexDirection: "column" }}
        >
          <Box
            sx={{
              pt: 3,
              fontSize: "13px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              color: "gray",
            }}
          >
            <HashLink to={"/product/" + link + "#top"}>
              <KeyboardBackspaceIcon sx={{ paddingTop: "3px" }} />
            </HashLink>
            <HashLink to={"/product/" + link + "#top"}>
              &nbsp;{t("Go back to the product")}
            </HashLink>
          </Box>

          <Box
            sx={{
              pt: 3,
              fontSize: "18px",
              fontWeight: 600,
              pb: "10px",
              color: "#153a5a",
            }}
          >
            {t(name)}{" "}
            <span style={{ color: "gray" }}>
              {" "}
              {location === "KO" ? "한국 사용자 " : "미국 사용자 "}
              {t("All reviews")}
            </span>
          </Box>
          <Box sx={{ pt: 1, fontSize: "14px", color: "gray", pb: 2 }}>
            {t("We found ")}
            {reviews.length}
            {t(" matching reviews")}
          </Box>

          {loading && <CircularProgress />}
          {!loading && (
            <AllReviewsOnePage
              currentReview={reviews.slice(
                currentPage - 1 * numOfReviews,
                numOfReviews * (currentPage + 1)
              )}
            />
          )}
          <Box sx={{ display: "flex", pt: 3 }}>
            <Box sx={{ display: "flex" }}>
              {/* {currentPage === 0 ? (
                <Button disabled="disabled" onClick={(e) => setCurrentPage(0)}>
                  <FirstPageIcon />
                </Button>
              ) : (
                <Button onClick={(e) => setCurrentPage(0)}>
                  {" "}
                  <FirstPageIcon />
                </Button>
              )} */}
              {/* {currentPage === 0 ? (
                <Button
                  disabled="disabled"
                  onClick={(e) => handleChange(e, "Prev")}
                >
                  <ArrowBackIosIcon />
                </Button>
              ) : (
                <Button onClick={(e) => handleChange(e, "Prev")}>
                  <ArrowBackIosIcon />
                </Button>
              )} */}
              {/* <Pagination
                count={Math.ceil(reviews.length / numOfReviews)}
                page={currentPage + 1}
                onClick={handleChange}
                hidePrevButton
                hideNextButton
              /> */}

              <Pagination
                count={Math.ceil(reviews.length / numOfReviews)}
                variant="outlined"
                color="secondary"
                sx={{ my: 2 }}
                onChange={handleChange}
                page={currentPage}
              />

              {/* {currentPage === reviews.length / numOfReviews - 1 ? (
                <Button
                  disabled="disabled"
                  onClick={(e) => handleChange(e, "Next")}
                >
                  <ArrowForwardIosIcon />
                </Button>
              ) : (
                <Button onClick={(e) => handleChange(e, "Next")}>
                  <ArrowForwardIosIcon />
                </Button>
              )} */}

              {/* {currentPage === reviews.length / numOfReviews - 1 ? (
                <Button
                  disabled="disabled"
                  onClick={(e) =>
                    setCurrentPage(reviews.length / numOfReviews - 1)
                  }
                >
                  <LastPageIcon />
                </Button>
              ) : (
                <Button
                  onClick={(e) =>
                    setCurrentPage(reviews.length / numOfReviews - 1)
                  }
                >
                  <LastPageIcon />
                </Button>
              )} */}
            </Box>

            {/* {Array.apply(null, {
              length: Math.ceil(reviews.length / numOfReviews),
            }).map((e, i) => (
              <Box
                key={i}
                sx={{
                  border: "1px solid lightgray",
                  margin: "2px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  py: 1,
                  cursor: "pointer",
                }}
                onClick={(e) => setCurrentPage(i)}
              >
                {i + 1}
              </Box>
            ))} */}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default AllReviews;
